import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE, scrollToCompra } from '../lib/constants';
const badges = ['📄 100% PDF', '⚡️ Entrega Inmediata', '📚 16 Temas + 8 Bonos'];
export function Hero() {
  return <header className="px-4 pb-10 pt-6" data-id="element-67" data-mp="4mi3fau9loeh">
      <h1 className="mb-5 text-center font-display text-2xl font-extrabold leading-snug text-white" data-id="element-68" data-mp="4njp098wptag">
        Organizá tus clases de forma definitiva, sin complicarte de más y sin
        explicaciones confusas.
      </h1>

      <motion.button type="button" onClick={scrollToCompra} initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="block w-full overflow-hidden rounded-2xl ring-1 ring-white/15 focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-300" aria-label="Ver la oferta del Kit Profe de Fisicoquímica Resuelta" data-id="element-69" data-mp="x8jj3cboo8cg">
        <img src={PRODUCT_IMAGE} alt="Kit Profe de Fisicoquímica Resuelta: libro digital con 16 fichas de clase, planificador anual, banco de ejercicios y bonos" className="w-full" data-id="element-70" data-mp="3o7lprkf2kuls" />
      </motion.button>

      <p className="mt-6 text-center text-[15px] font-medium leading-relaxed text-teal-50/90" data-id="element-71" data-mp="3e84orgarj4w5">
        Ejercicios, gráficos explicativos, clases, adaptaciones para alumnos
        especiales y fichas imprimibles. Todo lo que necesitás para abordar tu
        clase sin problemas.
      </p>

      <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-72" data-mp="2qkwkn1p2m1vp">
        {badges.map(b => <li key={b} className="rounded-full border border-teal-300/30 bg-[#0f4c4c]/70 px-3 py-1.5 text-xs font-semibold text-teal-50" data-id="element-73" data-mp="2vjzq2n8yqa47">
            {b}
          </li>)}
      </ul>

      <div className="mt-6" data-id="element-74" data-mp="2lk8vklkejv44">
        <CTAButton sub="Acceso inmediato · Descarga al instante" data-id="element-75" data-mp="2lml8ulf7thau" />
      </div>

      <div className="mt-4 flex flex-col items-center gap-1" data-id="element-76" data-mp="s3cloaja7jqk">
        <div className="flex items-center gap-1" aria-label="Calificación 4.9 de 5 estrellas" data-id="element-77" data-mp="naa12rwhfkmi">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-78" data-mp="dd592bfyguxs" />)}
          <span className="ml-1 text-sm font-bold text-amber-300" data-id="element-79" data-mp="1b04aezhler20">4.9/5</span>
        </div>
        <p className="text-[11px] text-teal-100/70" data-id="element-80" data-mp="162ccnou9oapw">
          Docentes de secundaria de toda Argentina
        </p>
      </div>
    </header>;
}